<template lang="pug">
yz-dialog(v-model="showDialog" persistent scrollable max-width="560")
  yz-card
    yz-dialog-normal-header(title="Enable UOM conversion" @close="onClose")
    yz-dialog-normal-content.pa-6
      .d-flex.align-start
        yz-icon.mr-2(color="danger" size="20") mdi-alert-circle
        .yz-medium-body-sm.text-neutral-700 This will auto-convert the current stock to the new base unit. Review the conversion below before proceeding.
      yz-card.mt-6(outlined)
        .pa-4
          .yz-medium-body-xs.text-neutral-500 Conversion preview
          .yz-heading-8.text-neutral-700.mt-2 1 {{ previousUom }} → {{ formattedMultiplier }} {{ newBaseUom }}
          .yz-regular-body-sm.text-neutral-500.mt-3 Current stock on hand: {{ currentStockOnHand }} {{ previousUom }}
          .yz-regular-body-sm.text-neutral-700.mt-1 New stock on hand: {{ newStockOnHand }} {{ newBaseUom }}
    yz-dialog-normal-actions(cancel-label="Cancel" save-label="Confirm" :loading="isSaving" @cancel="onClose" @save="onConfirm")
</template>

<script>
import { mapActions } from 'vuex'

export default {
  props: {
    value: { type: Boolean, default: false },
    previousUom: { type: String, default: null },
    newBaseUom: { type: String, default: null },
    defaultUom: { type: String, default: null },
    multiplier: { type: Number, default: 1 },
    currentStockOnHand: { type: Number, default: 0 },
    companySlug: { type: String, default: null },
    medicationId: { type: [Number, String], default: null },
    uomConversions: { type: Array, default: () => [] },
    apiEndpoint: { type: String, default: null }
  },
  data() {
    return {
      isSaving: false
    }
  },
  computed: {
    showDialog: {
      get() { return this.value },
      set(val) { this.$emit('input', val) }
    },
    formattedMultiplier() {
      const v = Number(this.multiplier)
      return Number.isInteger(v) ? `${v}` : parseFloat(v.toFixed(4)).toString()
    },
    newStockOnHand() {
      const v = Number(this.currentStockOnHand) * Number(this.multiplier)
      return Number.isInteger(v) ? `${v}` : parseFloat(v.toFixed(2)).toString()
    }
  },
  methods: {
    ...mapActions(['showMessage']),
    onClose() {
      this.showDialog = false
    },
    async onConfirm() {
      // Mirrors BaseUomChangeDialog payload — Case 1: multiplier=1 (qty unchanged, only label changes).
      // Case 2: multiplier = scale(prevUom)/scale(newBase) (qty auto-converted to base unit).
      this.isSaving = true
      try {
        const url = this.apiEndpoint || `/clinics/${this.companySlug}/hq/medications/${this.medicationId}`
        await this.$axios.patch(url, {
          product: {
            uom: this.defaultUom || this.newBaseUom,
            uom_conversion_enabled: true,
            uom_conversions: this.uomConversions,
            base_uom_conversion: {
              uom: this.previousUom,
              convert_to: this.newBaseUom,
              multiplier: Number(this.multiplier)
            }
          }
        })
        this.$emit('confirmed')
        this.showDialog = false
      } catch {
        this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
      } finally {
        this.isSaving = false
      }
    }
  }
}
</script>
